exports.ecriture = function (nom_cle, valeur) {
  localStorage.setItem(nom_cle, valeur);
  return 'Écriture effectuée avec succès.';
};

exports.lecture = function (nom_cle) {
  result = localStorage.getItem(nom_cle);
  return result;
};
